import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo } from 'react';

import { MuiTypography } from '@/features/shared/material-ui';
import { HeaderContentProps } from './HeaderContent.interface';
import useStyles from './HeaderContent.styles';

const HeaderContent = ({ title = '', theme = Theme.light }: HeaderContentProps) => {
  const classes = useStyles({});
  const rootClasses = clsx(classes.root, `${theme}-theme`);

  return title ? (
    <MuiTypography variant="h4" color="inherit" className={rootClasses}>
      {title}
    </MuiTypography>
  ) : null;
};

export default memo(HeaderContent);
